import { embroideryPositionListGenerator, embroideryPositionFilter } from 'src/features/brands/hooks/useEmbroideryContent'
import { Embroidery, I18NText, StateObj } from 'src/types'

export const selectablePositionGenerator = (
  embroideries: Embroidery[],
  positionObjects: StateObj[],
  excludes: string[],
  isBuriedLiningFirstByYsrDirectLogo2Position: boolean, // 裏平にYSRダイレクトロゴ2が選択されていたら、裏平への通常刺繍は不可にする
  index: number
): StateObj[] => {
  const selectedPosition = embroideryPositionListGenerator(embroideries, index)
  const selectablePositionBase = embroideryPositionFilter(positionObjects, selectedPosition)
  const overAllSelectedPositions = embroideries.map((e) => e.position.value)
  // 裏平1段目が選択可能かどうか→可能な時は、2段目は選択できないようにしておきたい
  const isSelectableOfLiningFirst = selectablePositionBase.some((p) => p.value === 'leatherLiningFirst')
  const selectablePosition = (
    isSelectableOfLiningFirst ? selectablePositionBase.filter((p) => p.value !== 'leatherLiningSecond') : selectablePositionBase
  )
    .filter((p) => (!overAllSelectedPositions.includes(p.value) || p.value === embroideries[index].position?.value) && !excludes.includes(p.value))
    .filter((position) =>
      isBuriedLiningFirstByYsrDirectLogo2Position ? !['leatherLiningFirst', 'leatherLiningSecond'].includes(position.value) : true
    )
  return selectablePosition
}

// eslint-disable-next-line
export const isHalfWidthCharChecker = (str: string) => !str.match(/^[^\x01-\x7E\xA1-\xDF]+$/)

export const embroideryFlagGenerator = (e: Embroidery, t: I18NText) => {
  const { color, shadowColor, edgeColor, pointColor } = e
  const isShadowColor = shadowColor.value !== 'none' && shadowColor.value !== 'unselected'
  const isEdgeColor = edgeColor.value !== 'none' && edgeColor.value !== 'unselected'
  const isArribaFont = e.typeFace.value === 'arriba'
  const isUnSelectedPosition = e.position.value === ''
  const isUnSelectedTypeFace = e.typeFace.value === ''
  const isUnSelectedMainColor = e.color.value === 'unselected'
  const isUnselectedEmbroideryColor = color.value.length === 0
  const isSelectedTypeFace = [e.typeFace.label, e.typeFace.value].every((x) => x.length > 0)
  const disabledShadowColor = isEdgeColor || isUnselectedEmbroideryColor || !isSelectedTypeFace
  const disabledEdgeColor = isShadowColor || isUnselectedEmbroideryColor || !isSelectedTypeFace
  const shadowColorLabel = shadowColor.label
  const edgeColorLabel = edgeColor.label
  const pointColorLabel = pointColor?.label
  // const shadowColorLabel = isEdgeColor ? t.NO_SELECTION : shadowColor.label
  // const edgeColorLabel = isShadowColor ? t.NO_SELECTION : edgeColor.label
  // const pointColorLabel = isArribaFont ? pointColor?.label : t.NO_SELECTION
  return {
    shadowColorLabel,
    edgeColorLabel,
    pointColorLabel,
    disabledShadowColor,
    disabledEdgeColor,
    isArribaFont,
    isUnSelectedPosition,
    isUnSelectedTypeFace,
    isUnSelectedMainColor,
    isSelectedTypeFace
  }
}
